import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Stack, Typography } from "@mui/material";

interface Props {
  onCancel: () => void;
  onSubmit: () => void;
  is_ai: boolean;
}

const modalContent = {
  manual: {
    headerTitle: "Delete Meeting Note",
    message:
      "You are about to delete this meeting note. This action is permanent and cannot be undone. Are you sure you want to continue?",
    submitButtonText: "Delete Permanently"
  },
  ai: {
    headerTitle: "Remove AI Meeting Note",
    message:
      "This meeting note was generated by the Altius AI assistant and linked to a recorded meeting. Deleting it will only remove it from this document – the meeting itself and its transcript will remain available in the Meetings tab.",
    submitButtonText: "Remove from Document"
  }
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px"
};

export const DeleteMeetingSectionContent: React.FC<Props> = ({ onCancel, onSubmit, is_ai }) => {
  const content = is_ai ? modalContent.ai : modalContent.manual;

  return (
    <Stack
      sx={{
        ...style,
        display: "flex",
        flexDirection: "column",
        width: 500,
        p: "32px",
        borderRadius: "8px",
        bgcolor: "white",
        boxShadow:
          "0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)"
      }}
    >
      <Stack gap="24px">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ borderBottom: "1px solid #DAE0E2" }}
        >
          <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#0A3142" }}>{content.headerTitle}</Typography>
          <IconButton onClick={onCancel}>
            <CloseIcon className="icon" />
          </IconButton>
        </Stack>
        <Stack sx={{ width: "100%", padding: "16px" }}>
          <Typography sx={{ fontSize: "14px", fontWeight: "400", color: "#0A3142" }}>{content.message}</Typography>
        </Stack>

        <Stack direction="row" gap="10px" justifyContent="flex-end" alignItems="center">
          <Stack gap="10px" direction="row" alignItems="center">
            <Button onClick={onCancel} variant="outlined">
              Cancel
            </Button>
            <Button onClick={onSubmit} variant="contained">
              {content.submitButtonText}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
